import { render, staticRenderFns } from "./CreateRemind.vue?vue&type=template&id=c2055d18&scoped=true&"
import script from "./CreateRemind.vue?vue&type=script&lang=js&"
export * from "./CreateRemind.vue?vue&type=script&lang=js&"
import style0 from "./CreateRemind.vue?vue&type=style&index=0&id=c2055d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2055d18",
  null
  
)

export default component.exports